// https://coolors.co/8a4f7d-887880-88a096-bbab8b-ef8275
export const COLORS = {
  DEATHS: '#EF8275',
  HOSPITALIZED: '#8A4F7D',
  POSITIVE: '#887880',
  PENDING: '#BBAB8B',
  NEGATIVE: '#88A096'
}
